// removed by extract-text-webpack-plugin
module.exports = {"social-group":"index__social-group___3DJ_O","socialGroup":"index__social-group___3DJ_O","is-browser":"index__is-browser___UKZbT","isBrowser":"index__is-browser___UKZbT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/SocialGroup/index.css
// module id = 744
// module chunks = 12